import React, { useMemo } from "react";
import { Button } from "primereact/button";
import { BaseModal } from "../../../../components/Modal/BaseModal";
import { utils } from "../../../../utils/utils";
import { JsonModalProps } from "../types";
import { Copy } from "lucide-react";

const COPY_BUTTON_CLASSES = "!bg-gray-200 !border !border-gray-400 !text-gray-700 !shadow-sm w-7 h-7 min-w-[28px] min-h-[28px] p-0 rounded flex items-center justify-center hover:!bg-gray-300 hover:!border-gray-500 hover:!text-gray-800 hover:!shadow-md active:!shadow-sm transition-all duration-150 [&_.p-button-icon]:!text-xs [&_.p-button-icon]:!text-gray-700 [&_.p-button-icon]:!m-0 [&_.p-button-label]:!hidden";
const SCROLLBAR_CONTAINER_CLASSES = "relative bg-gray-50 rounded-md overflow-auto flex-1 min-h-[300px] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-track]:bg-gray-200 [&::-webkit-scrollbar-track]:rounded [&::-webkit-scrollbar-thumb]:bg-gray-400 [&::-webkit-scrollbar-thumb]:rounded hover:[&::-webkit-scrollbar-thumb]:bg-gray-500";

export const JsonModal: React.FC<JsonModalProps> = ({
    isOpen,
    toggle,
    title,
    icon,
    data,
    onCopy,
}) => {
    // Parse JSON strings before displaying
    const formattedData = useMemo(() => utils.parseJsonStrings(data), [data]);

    const handleCopy = () => {
        const jsonString = JSON.stringify(formattedData, null, 2);
        navigator.clipboard.writeText(jsonString).then(() => {
            if (onCopy) onCopy();
        });
    };

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={toggle}
            title={title}
            icon={icon}
            iconColor="var(--color-primary-500, #667eea)"
            width="80rem"
            closeOnBackdrop={true}
            closeOnEscape={true}
            showCloseButton={true}
            className="json-modal modal-xl"
        >
            <div className="relative min-h-[300px] max-h-[65vh]">
                <div className="relative bg-gray-100 border border-gray-300 rounded-lg p-2 overflow-hidden h-full flex flex-col">
                    <div className={SCROLLBAR_CONTAINER_CLASSES}>
                        <div className="sticky top-2 right-2 z-10 w-fit ml-auto mb-2">
                            <Button
                                icon={<Copy size={16} />}
                                onClick={handleCopy}
                                className={COPY_BUTTON_CLASSES}
                                tooltip="Copy JSON"
                                tooltipOptions={{ position: 'left' }}
                                text
                                rounded
                            />
                        </div>
                        <pre className="font-mono text-xs md:text-sm leading-relaxed m-0 whitespace-pre break-words text-gray-800 bg-gray-50 p-4 md:p-5">
                            {JSON.stringify(formattedData, null, 2)}
                        </pre>
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};